'use client';
module.exports = require('../dist/components/NerdWalletLogo/NerdWalletLogo');
